import { chain, includes } from 'lodash';
import { auth as useAuthStore } from 'src/store/auth';
import { userRoles } from 'src/utils/AppUtils';

export default {
  userUnits: (state) => {
    const auth = useAuthStore();
    const { userDetails } = auth;

    if (!userDetails) {
      return [];
    }

    if ([userRoles.MANAGER, userRoles.ADMINISTRATOR].includes(userDetails.role)) {
      return state.units;
    }
    return state.units.filter((unit) => includes(userDetails.units, unit.id));
  },

  unitsList: (state) => {
    const auth = useAuthStore();
    const { userDetails } = auth;

    if (!userDetails) {
      return [];
    }

    const hasAllUnits = [userRoles.MANAGER, userRoles.ADMINISTRATOR].includes(userDetails.role);

    return state.units
      .map((unit) => ({
        value: unit.id,
        label: unit.unitName,
        hint: chain([unit.city, unit.state]).compact().join(', ').value(),
        disable: !hasAllUnits && !includes(userDetails.units, unit.id),
      }))
      .sort((a, b) => (a.label || '').localeCompare(b.label || ''));
  },
};
